<template>
  <div class="editPass">
    <div class="top">
      <van-icon size="22px" name="arrow-left" @click="back" />
      <span class="title">{{ $t('append_field.change_password')}}</span>
    </div>
    <div class="editPass-body">
      <div class="ps">
        {{$t('append_field.current_password_too_simple')}}
      </div>
      <input type="password" class="pass-input" v-model="input"/>
      <div class="error-msg">{{error}}</div>
      <van-button block class="pass-btn" @click="onSubmit">
        {{$t('append_field.modify')}}
      </van-button>

    </div>
  </div>
</template>

<script>
import qs from "qs";

const CryptoJS = require('crypto-js')

function encrypt(data) {
  var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
  key = CryptoJS.enc.Hex.parse(key)
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
  var enc = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  var enced = enc.ciphertext.toString()
  return enced
}

export default {
  data() {
    return {
      input: "",
      error: "",
    }
  },
  methods: {
    onSubmit() {
      this.error = ""
      var reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[~@#$%^&+=!()*]).*$/
      if (!reg.test(this.input)) {
        this.error = this.$t('append_field.please_enter_password')
        return
      }

      this.$ajax.post("/etv/updatePasswordToSafe.json", qs.stringify({
        password: encrypt(this.input)
      })).then(res => {
        if (res.data.code === 0) {
          this.$ajax.post('/etv/logout.json').then(() => {
            this.$router.push('/login')
            localStorage.clear()
          })
        }
      })
    },
    back() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped lang="scss">
.editPass {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .top{
    padding:18px 10px;
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    justify-content: center; /* 水平居中对齐 */
    position: relative; /* 使子元素可以相对于父元素定位 */
    border-bottom: #8c8c8c 1px solid;

    .van-icon {
      position: absolute; /* 绝对定位 */
      left: 10px; /* 根据需要调整左边距 */
    }
    .title{
      font-size: 18px;
      font-size: 18px;
      float: none; /* 确保不使用浮动 */
      display: inline-block; /* 使元素成为行内块级元素 */
    }
  }
  .editPass-body {
    padding: 10px 16px;
    .ps {
      color: red;
      font-size: 16px;
    }

    .pass-input {
      height: 40px;
      width: 100%;
      padding-left: 10px;
      box-sizing: border-box;
      border: 1px solid #c1c1c1;
      outline: none;
      margin-top: 20px;
      border-radius: 3px;
    }

    .error-msg {
      height: 20px;
      font-size:  15px;
      color: red;
    }

    .pass-btn {
      width: 100%;
      height: 44px;
      color: #ffffff;
      outline: none;
      border-radius: 15px;
      background: #006EFF;
      border: 1px solid #006EFF;
      margin-top: 30px;
    }
  }
}
</style>
